import logisticsApi from "services/logisticsApi";
import { DealerDriversResponse } from "types/dealerDrivers";

export type DealerDriverStatus = "online" | "offline" | "disabled";

type GetDealerDriversOptions = {
  statuses?: DealerDriverStatus[];
  limit?: number;
  offset?: number;
};

function serializeDriversParams(params: Record<string, unknown>): string {
  const searchParams = new URLSearchParams();
  const { limit, offset, statuses } = params;

  if (limit !== undefined && limit !== null && limit !== "") {
    searchParams.append("limit", String(limit));
  }
  if (offset !== undefined && offset !== null && offset !== "") {
    searchParams.append("offset", String(offset));
  }
  if (Array.isArray(statuses)) {
    statuses.forEach((status) => {
      const normalizedStatus = String(status ?? "").trim();
      if (normalizedStatus) {
        searchParams.append("statuses", normalizedStatus);
      }
    });
  }

  return searchParams.toString();
}

export async function getDealerDrivers(
  dealerId: string,
  options?: GetDealerDriversOptions,
): Promise<DealerDriversResponse> {
  const { data } = await logisticsApi.get<DealerDriversResponse>(
    `/v1/dealers/${dealerId}/drivers`,
    {
      params: {
        statuses: options?.statuses,
        limit: options?.limit,
        offset: options?.offset,
      },
      paramsSerializer: serializeDriversParams,
    },
  );

  return data;
}
